<template>
  <el-tag v-if="state && stateLabel" size="medium" :type="cssClass"
    >{{ stateLabel }}
  </el-tag>
</template>

<script>
import constants from "../../../constants";
import hanhChinhUtils from "../../../services/hanhChinhUtils";

export default {
  name: "hc-dieuxe-state",
  props: ["state"],

  computed: {
    stateLabel() {
      return hanhChinhUtils.getDieuXeStateLabel(this.state);
    },

    cssClass() {
      switch (this.state) {
        case constants.HC_STATE.STATE_CODE.DIEU_XE.HUY:
          return "danger";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.DA_PHE_DUYET:
          return "success";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.CHO_PHE_DUYET:
          return "";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.TU_CHOI:
          return "danger";
        default:
          return "";
      }
    }
  },

  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-state.vue